
import { HttpEvent, HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonResponse } from '../models/responses/common.response';
import { GroupAgeResponse } from '../models/responses/group-age.response';
import { NationalityResponse } from '../models/responses/nationality.response';
import { TicketTypeResponse } from '../models/responses/ticket-type.response';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseURL: string = environment.API_URL;

  constructor(
    private request: RequestService,
    private http: HttpClient
  ) { }
  // getNationalities(): Observable<NationalityResponse> {
  //   return this.request.getJSON<NationalityResponse>(
  //     '/assets/data/countries.json'
  //   );
  // }
  getTicketType(params: { system: string, channel: string }): Observable<TicketTypeResponse>  {
    const url = this.baseURL + "ticket-type";
    return this.request.getJSON<TicketTypeResponse>(url, params);
  }
  getOrders(queries?: { [key: string]: string | number }): Observable<CommonResponse> {
    const url = this.baseURL + "order";
    return this.request.getJSON(url, queries);
    // return this.request.get<any>(url, queries, reportProgress, 'json', 'events');
  }

  // getOrderById(id: string): Observable<any> {
  //   const url = this.baseURL + 'order/' + id;
  //   return this.request.getJSON<any>(url);
  // }

  // getOrderById(id: string): Observable<any> {
  //   const url = `${environment.API_URL_V2}order/confirmation/${id}`;
  //   return this.request.getJSON<any>(url);
  // }
  getOrderById(id: string): Observable<any> {
    const url = `${environment.API_URL_V2}order/confirmation-web/${id}`;
    return this.request.getJSON<any>(url);
  }
  // deleteOrder(id: string): Observable<CommonResponse> {
  //   const url = this.baseURL + ""
  // }
  getGroupAge(): Observable<GroupAgeResponse> {
    const url = this.baseURL + 'group-age';
    return this.request.getJSON<GroupAgeResponse>(url);
  }
  createOrder(data: { system: string, tickets: any[] }): Observable<any> {
    const url = environment.API_URL_V2 + 'order';
    return this.request.postJSON(url, data)
  }

  createOrderV3(data: { system: string, tickets: any[], recaptchaToken: string }): Observable<any> {
    const url= environment.API_URL_V3 + 'order';
    return this.request.postJSON(url, data);
  }
  uploadFile(file): Observable<any> {
    const url = this.baseURL + 'file/upload';
    const data = new FormData();
    data.append("file", file);
    return this.request.postJSON(url, data);
  }
  getFileByID(id: string): Observable<any> {
    const url = this.baseURL + 'file/' + id;
    return this.request.get(url, null, false, "blob");
  }
  getNationalities(data?: { [key: string]: any}): Observable<CommonResponse> {
    const url = environment.API_URL_V2 + "nationalities";
    return this.request.getJSON(url, data);
  }
  getOrderSummary(queries?: { [key: string]: any }): Observable<CommonResponse> {
    const url = this.baseURL + "summary/order"
    return this.request.getJSON<CommonResponse>(url, queries);
  }
  deleteUnpaidOrder(id: string): Observable<CommonResponse> {
    const url = this.baseURL + "order/" + id;
    return this.request.delete(url);
  }
  updateOrderByID(params, id): Observable<CommonResponse> {
    const url = environment.API_URL_V2 + "order/" + id;
    return this.request.putJSON(url, params);
  }
  piadOnOrder(orderID: string, order): Observable<CommonResponse> {
    const url = this.baseURL + "order/" + orderID + "/paid";
    return this.request.putJSON(url, order);
  }
  submitOrder(orderID: string, system: string): Observable<CommonResponse> {
    const url = environment.API_URL_V2 + 'order/submit';
    return this.request.postJSON<CommonResponse>(url, { order_id: orderID, system: system });
  }
  submitOrderForMobile(orderID: string, token: string): Observable<CommonResponse> {
    const url = this.baseURL + 'order/submit';
    let headers = new HttpHeaders({
      Authorization: token
    });
    return this.request.customPostJSON<CommonResponse>(url, { order_id: orderID }, headers);
  }
  paymentDATAForMobile(data: { order_id: string, bank_name: string }, token: string): Observable<CommonResponse> {
    const url = this.baseURL + "payment/data";
    let headers = new HttpHeaders({
      Authorization: token
    });
    return this.request.customPostJSON<CommonResponse>(url, data, headers);
  }
  paymentDATA(data: { order_id: string, payment_id?: string, bank_name: string, recaptcha_v3_token: string }): Observable<CommonResponse> {
    const url = this.baseURL + "payment/data";
    return this.request.postJSON<CommonResponse>(url, data);
  }

  paymentDataV3(data: { order_id: string, bank_name?: string, client_type: string, payment_option: string, recaptcha_v3_token: string }): Observable<CommonResponse> {
    const url = environment.API_URL_V3 + "payment/data";
    return this.request.postJSON<CommonResponse>(url, data);
  }

  getBanks(): Observable<CommonResponse> {
    const url = environment.API_URL_V3 + "payment-options-data?channel=web";
    return this.request.getJSON<CommonResponse>(url);
  }

  getBankImage(bank_id: string):Observable<any> {
    const url = environment.API_URL_V3 + "banks/" + bank_id + "image";
    return this.request.get(url, null, false, "blob");
  }

  checkTransaction(data: { invoice?: string, order_id: string, is_local: number }): Observable<CommonResponse> {
    const url = environment.API_URL_V3 + 'payment/check-tran';
    return this.request.postJSON<CommonResponse>(url, data);
  }


  downloadOrderReciept(orderID: string): Observable<any> {
    return this.request.get(this.baseURL + 'receipt/' + orderID, null, false, 'blob');
  }

  downloadOrderTickets(orderID: string): Observable<any> {
    return this.request.get(this.baseURL + 'ticket/download/' + orderID, null, false, 'blob');
  }
  /**
     *
     * @param search
     * @param pagination
     * @returns
     */
  getTicketByType(search:any): Observable<any> {
    const url = this.baseURL + "order"
    return this.request.getJSON<any>(url, search);
  }

  reSubmitOrder(orderID: string): Observable<CommonResponse> {
    const url = this.baseURL + 'order/re-submit';
    return this.request.postJSON<CommonResponse>(url, { order_id: orderID });
  }

  getPassOfPurchase(): Observable<CommonResponse> {
    const url = environment.API_URL_V2 + 'ticket-system-infos'
    return this.request.getJSON<any>(url);
  }

  getDatailPassOfPurchase(_id: string): Observable<CommonResponse> {
    const url = environment.API_URL_V2 + 'ticket-system-infos/' + _id;
    return this.request.getJSON<any>(url);
  }

  getImageOfSystem(_id: string): Observable<any> {
    const url = environment.API_URL_V2 + 'web/ticket-system-info-files/' + _id;
    return this.request.get(url, null, false, "blob");
  }

  getContactUsContent(): Observable<CommonResponse> {
    const url = environment.API_AE_ADMIN_URL + '/contact';
    return this.request.getJSON<CommonResponse>(url);
  }
}
